export default __webpack_public_path__ + "static/media/trybook2.c503e678.png";